'use strict';
/* COMPONENT - c.07.01 - search results */

import Listing from './uif_listing.js';

if (document.querySelector('.search-results')) {
    new Listing(document.querySelector('.search-results'));
}
